import * as tslib_1 from "tslib";
import { Transform, Type } from 'class-transformer';
import { CashReceiptAttachmentRawDto } from './cash-receipt-attachment-raw-dto';
import { GLJournalRawDto } from '../../../../cirabooks-module/_models/general-ledger/gl-journal-raw-dto';
import { PointOfSaleTransactionRawDto } from '../../common/point-of-sale-transaction-raw-dto';
import { CashReceiptItemRawDto } from './cash-receipt-item-raw-dto';
import { dateJSONTransformer } from '../../../../../_constants/validation-format-constants';
const ɵ0 = () => GLJournalRawDto, ɵ1 = () => Date, ɵ2 = () => Date, ɵ3 = () => PointOfSaleTransactionRawDto, ɵ4 = () => Date, ɵ5 = () => Date, ɵ6 = () => CashReceiptItemRawDto, ɵ7 = () => CashReceiptAttachmentRawDto;
export class CashReceiptRawDto {
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", GLJournalRawDto)
], CashReceiptRawDto.prototype, "glJournal", void 0);
tslib_1.__decorate([
    Type(ɵ1),
    Transform(dateJSONTransformer, { toPlainOnly: true }),
    tslib_1.__metadata("design:type", Date)
], CashReceiptRawDto.prototype, "receiveDate", void 0);
tslib_1.__decorate([
    Type(ɵ2),
    Transform(dateJSONTransformer, { toPlainOnly: true }),
    tslib_1.__metadata("design:type", Date)
], CashReceiptRawDto.prototype, "postDate", void 0);
tslib_1.__decorate([
    Type(ɵ3),
    tslib_1.__metadata("design:type", Array)
], CashReceiptRawDto.prototype, "pointOfSaleTransactions", void 0);
tslib_1.__decorate([
    Type(ɵ4),
    Transform(dateJSONTransformer, { toPlainOnly: true }),
    tslib_1.__metadata("design:type", Date)
], CashReceiptRawDto.prototype, "transactionDate", void 0);
tslib_1.__decorate([
    Type(ɵ5),
    Transform(dateJSONTransformer, { toPlainOnly: true }),
    tslib_1.__metadata("design:type", Date)
], CashReceiptRawDto.prototype, "reversedDate", void 0);
tslib_1.__decorate([
    Type(ɵ6),
    tslib_1.__metadata("design:type", Array)
], CashReceiptRawDto.prototype, "items", void 0);
tslib_1.__decorate([
    Type(ɵ7),
    tslib_1.__metadata("design:type", Array)
], CashReceiptRawDto.prototype, "attachments", void 0);
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7 };
